export const MAINTENANCE_MODE_DEV_API_URL = 'https://kloans-application-web-gateway.k8s.dev.kasasaonline.com/api/v1/kloans-loan-application/maintenance';

export const MAINTENANCE_MODE_UAT_API_URL = 'https://kloans-application-web-gateway.k8s.uat.kasasaonline.com/api/v1/kloans-loan-application/maintenance';

export const MAINTENANCE_MODE_PROD_API_URL = 'https://kloans-application-web-gateway.k8s.prod.kasasaonline.com/api/v1/kloans-loan-application/maintenance';
